import React, { Suspense, lazy, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ScrollToTop } from './components/ScrollToTop';
import { LoadingSpinner, MinimalSpinner } from './components/LoadingSpinner';
import { FloatingUtilities } from './components/FloatingUtilities';
import { ConditionalHeader } from './components/ConditionalHeader';
import { Footer } from './components/Footer';
import { LeadFormDialog } from './components/LeadFormDialog';

// Lazy load all page components for optimal bundle splitting
const HomePage = lazy(() => import('./pages/HomePage').then(module => ({ default: module.HomePage })));
const BlogsPage = lazy(() => import('./pages/BlogsPage').then(module => ({ default: module.BlogsPage })));
const BlogViewPage = lazy(() => import('./pages/BlogViewPage').then(module => ({ default: module.BlogViewPage })));
const CareersPage = lazy(() => import('./pages/CareersPage').then(module => ({ default: module.CareersPage })));
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage').then(module => ({ default: module.PrivacyPolicyPage })));
const TermsOfServicePage = lazy(() => import('./pages/TermsOfServicePage').then(module => ({ default: module.TermsOfServicePage })));
const SecurityCompliancePage = lazy(() => import('./pages/SecurityCompliancePage').then(module => ({ default: module.SecurityCompliancePage })));
const OdishaIndustryLanding = lazy(() => import('./pages/OdishaIndustryLanding').then(module => ({ default: module.OdishaIndustryLanding })));
const OdishaPlatformLanding = lazy(() => import('./pages/OdishaPlatformLanding').then(module => ({ default: module.OdishaPlatformLanding })));
const OdishaServiceLanding = lazy(() => import('./pages/OdishaServiceLanding').then(module => ({ default: module.OdishaServiceLanding })));
const AboutPage = lazy(() => import('./pages/AboutPage').then(module => ({ default: module.AboutPage })));
const ContactPage = lazy(() => import('./pages/ContactPage').then(module => ({ default: module.ContactPage })));
const ConsultingPage = lazy(() => import('./pages/ConsultingPage').then(module => ({ default: module.ConsultingPage })));
const SmallBusinessPage = lazy(() => import('./pages/SmallBusinessPage').then(module => ({ default: module.SmallBusinessPage })));
const PlatformPage = lazy(() => import('./pages/PlatformPage').then(module => ({ default: module.PlatformPage })));
const CaseStudiesPage = lazy(() => import('./pages/CaseStudiesPage').then(module => ({ default: module.CaseStudiesPage })));
const OdishaWebDesignLanding = lazy(() => import('./pages/OdishaWebDesignLanding').then(module => ({ default: module.OdishaWebDesignLanding })));

function App() {
  const [isLeadFormOpen, setIsLeadFormOpen] = useState(false);

  return (
    <div className="min-h-screen bg-background font-sans antialiased">
      <Router>
        <ConditionalHeader onGetStarted={() => setIsLeadFormOpen(true)} />
        <ScrollToTop />
        <FloatingUtilities />
        <Suspense fallback={<LoadingSpinner message="Loading page..." />}>
          <Routes>
            <Route path="/" element={
              <Suspense fallback={<MinimalSpinner />}>
                <HomePage />
              </Suspense>
            } />
            <Route path="/blogs" element={
              <Suspense fallback={<MinimalSpinner />}>
                <BlogsPage />
              </Suspense>
            } />
            <Route path="/blog/:slug" element={
              <Suspense fallback={<MinimalSpinner />}>
                <BlogViewPage />
              </Suspense>
            } />
            <Route path="/careers" element={
              <Suspense fallback={<MinimalSpinner />}>
                <CareersPage />
              </Suspense>
            } />
            <Route path="/privacy-policy" element={
              <Suspense fallback={<MinimalSpinner />}>
                <PrivacyPolicyPage />
              </Suspense>
            } />
            <Route path="/terms-of-service" element={
              <Suspense fallback={<MinimalSpinner />}>
                <TermsOfServicePage />
              </Suspense>
            } />
            <Route path="/security-compliance" element={
              <Suspense fallback={<MinimalSpinner />}>
                <SecurityCompliancePage />
              </Suspense>
            } />
            <Route path="/odisha-industry-landing" element={
              <Suspense fallback={<MinimalSpinner />}>
                <OdishaIndustryLanding />
              </Suspense>
            } />
            <Route path="/odisha-platform-landing" element={
              <Suspense fallback={<MinimalSpinner />}>
                <OdishaPlatformLanding />
              </Suspense>
            } />
            <Route path="/odisha-service-landing" element={
              <Suspense fallback={<MinimalSpinner />}>
                <OdishaServiceLanding />
              </Suspense>
            } />
            <Route path="/odisha-webdesign-landing" element={
              <Suspense fallback={<MinimalSpinner />}>
                <OdishaWebDesignLanding />
              </Suspense>
            } />
            <Route path="/about" element={
              <Suspense fallback={<MinimalSpinner />}>
                <AboutPage />
              </Suspense>
            } />
            <Route path="/contact" element={
              <Suspense fallback={<MinimalSpinner />}>
                <ContactPage />
              </Suspense>
            } />
            <Route path="/consulting" element={
              <Suspense fallback={<MinimalSpinner />}>
                <ConsultingPage />
              </Suspense>
            } />
            <Route path="/small-business" element={
              <Suspense fallback={<MinimalSpinner />}>
                <SmallBusinessPage />
              </Suspense>
            } />
            <Route path="/platform" element={
              <Suspense fallback={<MinimalSpinner />}>
                <PlatformPage />
              </Suspense>
            } />
            <Route path="/case-studies" element={
              <Suspense fallback={<MinimalSpinner />}>
                <CaseStudiesPage />
              </Suspense>
            } />
          </Routes>
        </Suspense>
        <Footer />
        <LeadFormDialog 
          isOpen={isLeadFormOpen} 
          onClose={() => setIsLeadFormOpen(false)} 
        />
      </Router>
    </div>
  );
}

export default App;
